import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, BrowserRouter } from "react-router-dom";

import ConfigPage from "./pages/ConfigPage";
import ConfigListPage from "./pages/ConfigListPage";
import Dashboard from "./pages/Dashboard";
import MainLayout from "./components/MainLayout";
import ReconciliationSummary from "./pages/ReconciliationSummary";
import SettingsPage from "./pages/SettingPage";
import RootCauseAnalysis from "./pages/RootCauseAnalysis";
import AgencyReconciliationPage from "./pages/AgencyReconciliationPage";
import AgencyDrillDownPage from "./pages/AgencyDrillDownPage";
import TransactionReviewResolutionPage from "./pages/TransactionReviewResolutionPage";
import ColumnRelationDesignerScreen from "./pages/ColumnRelationDesignerScreen";
import TransformationRulesPage from "./pages/TransformationRulesPage";
import { initKeycloak } from "./auth";
import ProgramCreatePage from "./pages/ProgramCreatePage";

export default function App() {

  return (
     <BrowserRouter>
      <Routes>

        {/* ALL PAGES INSIDE LAYOUT */}
          <Route element={<MainLayout />}>
            {/* <Route path="/" element={<Dashboard />} /> */}
             <Route path="/" element={<ProgramCreatePage />} />
            <Route path="/programs/config/*" element={<ConfigPage />} />
            {/* <Route path="/program" element={<ProgramCreatePage />} /> */}
            <Route path="/programs/configs/*" element={<ConfigListPage />} />
            <Route path="/programs/config/run/summary/*" element={<ReconciliationSummary />} />
            <Route path="/settings/*" element={<SettingsPage />} />
            <Route path="/programs/config/run/analysis/*" element={<RootCauseAnalysis></RootCauseAnalysis>}/>
            <Route path="/programs/config/run/agency/*" element={<AgencyReconciliationPage></AgencyReconciliationPage>}/>
            <Route path="/programs/config/run/agency/details/:id" element={<AgencyDrillDownPage />} />
            <Route path="/programs/config/run/transaction-review/*" element={<TransactionReviewResolutionPage/>}/>
            <Route path="/programs/config/column-mapping/*" element={<ColumnRelationDesignerScreen />} />
            <Route path="/transform-rule/*" element={<TransformationRulesPage />} />
          </Route>
      </Routes>
    </BrowserRouter>
  );
}